// components/SectionDivider.jsx
import { motion } from "framer-motion";

const SectionDivider = ({ label }) => (
  <div className="flex items-center my-8">
    <motion.div
      className="flex-grow h-[1px] bg-gray-300"
      initial={{ scaleX: 0 }}
      animate={{ scaleX: 1 }}
      transition={{ duration: 0.6 }}
    />
    <span className="px-4 text-gray-500 text-sm">{label}</span>
    <motion.div
      className="flex-grow h-[1px] bg-gray-300"
      initial={{ scaleX: 0 }}
      animate={{ scaleX: 1 }}
      transition={{ duration: 0.6, delay: 0.2 }}
    />
  </div>
);

export default SectionDivider;
